import { useState, type ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HTTPError } from 'ky'
import { AuthProvider, useAuth } from '@frontend/contexts/AuthContext'

function QueryProvider({ children }: { children: ReactNode }) {
  const { clearAuth } = useAuth()

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: (failureCount, error) => {
              // Don't retry on 401
              if (error instanceof HTTPError && error.response.status === 401) {
                return false
              }
              return failureCount < 3
            },
            staleTime: 1000 * 60, // 1 minute
          },
          mutations: {
            onError: (error) => {
              // Clear auth on 401
              if (error instanceof HTTPError && error.response.status === 401) {
                clearAuth()
              }
            },
          },
        },
      })
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <QueryProvider>{children}</QueryProvider>
    </AuthProvider>
  )
}
